module.exports = __webpack_public_path__ + "static/desktop_logo-858bc7f955017a4268d708f37b25771c.png";